
import { useEffect, useRef, useState } from 'react';
import ProfileImageGallery from './about/ProfileImageGallery';
import AboutContent from './about/AboutContent';

const AboutSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => {
      observer.disconnect();
    };
  }, []);
  
  return (
    <section id="about" className="bg-secondary/30 relative" ref={sectionRef}>
      <div className="about-vector about-vector-1"></div>
      <div className="about-vector about-vector-2"></div>
      
      <div className="section-container relative z-10">
        <div className={`max-w-3xl mx-auto transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
        }`}>
          <p className="heading-highlight mb-2 animate-pulse-slow">About Me</p>
          <h2 className="text-3xl font-bold mb-8">My Background</h2>
          
          <div className="flex flex-col md:flex-row gap-8 items-start mb-8">
            <div className={`transition-all duration-500 delay-[200ms] ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
            }`}>
              <ProfileImageGallery />
            </div>
            
            <AboutContent isVisible={isVisible} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
